/* eslint-disable import/no-named-default */
import React from 'react';
import PropTypes from 'prop-types';

import { List, ListItem } from '@xingternal/list';

import { Headline, BodyCopy } from '@xingternal/typography';

import { StatusBanner } from '@xingternal/banner';

const Message = ({ headline, children, type, small, ...props }) => {
  const messageFlags = {
    information: 'info',
    error: 'error',
  };
  const bannerProps = {
    [messageFlags[type]]: true,
    ...props,
  };

  return (
    <StatusBanner {...bannerProps}>
      <List>
        {headline && (
          <ListItem style={{ paddingTop: 0 }}>
            {small ? (
              <Headline size="medium" noMargin>
                {headline}
              </Headline>
            ) : (
              <Headline size="xlarge" noMargin>
                {headline}
              </Headline>
            )}
          </ListItem>
        )}
        <ListItem>
          <BodyCopy size="medium" noMargin>
            {children}
          </BodyCopy>
        </ListItem>
      </List>
    </StatusBanner>
  );
};

Message.defaultProps = {
  small: false,
};

Message.propTypes = {
  /** message body as string text or react children */
  children: PropTypes.node.isRequired,
  /** has to be one of information, error */
  type: PropTypes.oneOf(['error', 'information']).isRequired,
  /** renders an optional headline */
  headline: PropTypes.node,
  /** defines if the small display has to be used */
  small: PropTypes.bool,
  /** define a testid for the messsage */
  testId: PropTypes.string,
};

Message.displayName = 'Message';

export default Message;
